export const getPlayerStats = async (tag: string) => {
  const formattedTag = tag.startsWith('#') ? tag.slice(1) : tag;
  
  try {
    const response = await fetch(`https://brawlstars-stats-tracker.vercel.app/api/player/${formattedTag}`);

    if (!response.ok) {
      if (response.status === 503) {
        throw new Error(JSON.stringify({
          response: { status: 503 },
          details: { reason: 'inMaintenance' }
        }));
      }
      throw new Error('플레이어를 찾을 수 없습니다');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching player data:', error);
    throw error;
  }
}; 